import { render, staticRenderFns } from "./DbpyExL.vue?vue&type=template&id=4f7947c8"
import script from "./DbpyExL.vue?vue&type=script&lang=js"
export * from "./DbpyExL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports